import * as types from './mutation-types'
import InstitutionApi from '@/api/institution'

const getInstitutions = async ({commit}, {params, state}) => {
  const res = await InstitutionApi.get(params)
  const institutions = res.data.data
  const meta = res.data.meta
  if (institutions.length > 0) {
    state.loaded()
    commit(types.SET_INSTITUTIONS, institutions)
    commit(types.SET_INSTITUTIONS_META, meta)
  } else {
    state.complete()
  }
}

const getGroups = async ({commit}, {offset, state}) => {
  const res = await InstitutionApi.get({offset})
  const groups = res.data.data
  if (groups.length > 0) {
    state.loaded()
    commit(types.SET_GROUPS, groups)
  } else {
    state.complete()
  }
}

const searchInstitutions = async ({commit}, {params}) => {
  const res = await InstitutionApi.get(params)
  return res
}

const showGroupChildren = ({commit}, employeeCode) => {
  commit(types.SET_GROUP_SELECTED, employeeCode)
}

const clearUnreadMessages = ({commit}, payload) => {
  commit(types.CLEAR_UNREAD_MESSAGES, payload)
}

const setCurrentPos = ({commit}, pos) => {
  commit(types.SET_CURRENT_POST, pos)
}

export default {
  getInstitutions,
  searchInstitutions,
  getGroups,
  showGroupChildren,
  clearUnreadMessages,
  setCurrentPos
}



// WEBPACK FOOTER //
// ./src/store/modules/institution/actions.js